/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AcceptancesControllerAcceptMutationResponse, AcceptancesControllerAcceptPathParams, AcceptancesControllerAccept400, AcceptancesControllerAccept401, AcceptancesControllerAccept404 } from "../../models/acceptancesController/AcceptancesControllerAccept";

function getAcceptancesControllerAcceptUrl(principalId: AcceptancesControllerAcceptPathParams["principalId"], principalType: AcceptancesControllerAcceptPathParams["principalType"]) {
  const res = { method: 'POST', url: `/api/v1/acceptances/${principalType}/${principalId}/accept` as const }  
  return res
}

/**
 * @summary Accept an agreement
 * {@link /api/v1/acceptances/:principalType/:principalId/accept}
 */
export async function acceptancesControllerAccept(principalId: AcceptancesControllerAcceptPathParams["principalId"], principalType: AcceptancesControllerAcceptPathParams["principalType"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<AcceptancesControllerAcceptMutationResponse, ResponseErrorConfig<AcceptancesControllerAccept400 | AcceptancesControllerAccept401 | AcceptancesControllerAccept404>, unknown>({ method : "POST", url : getAcceptancesControllerAcceptUrl(principalId, principalType).url.toString(), ... requestConfig })  
  return res.data
}